"use strict";

exports.__esModule = true;
exports.TYPE_OPTIONS = exports.TOKENS = void 0;
let TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["INFO"] = "info";
  TYPE_OPTIONS["SUCCESS"] = "success";
  TYPE_OPTIONS["WARNING"] = "warning";
  TYPE_OPTIONS["CRITICAL"] = "critical";
  TYPE_OPTIONS["INFO_SUBTLE"] = "infoSubtle";
  TYPE_OPTIONS["SUCCESS_SUBTLE"] = "successSubtle";
  TYPE_OPTIONS["WARNING_SUBTLE"] = "warningSubtle";
  TYPE_OPTIONS["CRITICAL_SUBTLE"] = "criticalSubtle";
  TYPE_OPTIONS["SECONDARY"] = "secondary";
  return TYPE_OPTIONS;
}({});
exports.TYPE_OPTIONS = TYPE_OPTIONS;
let TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["backgroundButton"] = "backgroundButton";
  TOKENS["backgroundButtonHover"] = "backgroundButtonHover";
  TOKENS["backgroundButtonActive"] = "backgroundButtonActive";
  TOKENS["backgroundButtonFocus"] = "backgroundButtonFocus";
  TOKENS["colorTextButton"] = "colorTextButton";
  TOKENS["colorTextButtonHover"] = "colorTextButtonHover";
  TOKENS["colorTextButtonActive"] = "colorTextButtonActive";
  TOKENS["borderColorButtonFocus"] = "borderColorButtonFocus";
  return TOKENS;
}({});
exports.TOKENS = TOKENS;